"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.TabNavItemWrapper = exports.SelectOption = exports.SelectChildrenWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const calculateIndent = indent => {
  const BASE = 8;
  const INDENT_PADDING_LI = indent === 1 ? BASE * 3 : (indent + 2) * BASE;
  return /*#__PURE__*/(0, _react.css)("padding-left:", INDENT_PADDING_LI, "px!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:calculateIndent;"));
};
const TabNavItemWrapper = exports.TabNavItemWrapper = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e169sb432"
} : {
  target: "e169sb432",
  label: "TabNavItemWrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;border:none;background:transparent;cursor:pointer;padding:1rem;position:relative;font-size:16px;font-weight:bold;transition:all ease 250ms;&:hover{&::after{position:absolute;content:'';width:100%;height:4px;bottom:0;left:0;background-color:", props.theme.primary, ";z-index:1;opacity:0.4;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:TabNavItemWrapper;")));
const SelectChildrenWrapper = exports.SelectChildrenWrapper = /*#__PURE__*/(0, _base.default)("ul", process.env.NODE_ENV === "production" ? {
  target: "e169sb431"
} : {
  target: "e169sb431",
  label: "SelectChildrenWrapper"
})(props => /*#__PURE__*/(0, _react.css)("position:absolute;z-index:3;top:calc(", props.bottom, "px - 0.5em);left:", props.left, "px;background:#fff;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);list-style:none;margin:0;padding:0;min-width:", props.minWidth, "px;max-width:350px;max-height:40vh;overflow-y:auto;overflow-x:hidden;&>li{word-break:break-all;background:#fff;display:flex;width:calc(100% - 1em);cursor:pointer;list-style:none;padding:0.5em;padding-left:1em;border-top:1px solid ", props.theme.border, ";transition:background 150ms ease-in-out;&:first-of-type{border-top:none;}&:hover,&:focus{background:", props.theme.bgLight, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:SelectChildrenWrapper;")));
const SelectOption = exports.SelectOption = /*#__PURE__*/(0, _base.default)("li", process.env.NODE_ENV === "production" ? {
  target: "e169sb430"
} : {
  target: "e169sb430",
  label: "SelectOption"
})(({
  disabled,
  bold,
  indent
}) => /*#__PURE__*/(0, _react.css)("padding:0;padding-left:8px;padding-right:8px;justify-content:flex-start;height:100%;width:100%;opacity:", disabled ? 0.5 : 1, ";font-weight:", bold ? 600 : 400, ";", indent && calculateIndent(indent), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SelectOption;")));
const styles = exports.styles = {
  active: theme => /*#__PURE__*/(0, _react.css)("&::after{transition:all ease 250ms;position:absolute;content:'';width:100%;height:4px;bottom:0;left:0;background-color:", theme.primary, ";z-index:1;}" + (process.env.NODE_ENV === "production" ? "" : ";label:active;"))
};